const statuses = Object.freeze({
  Available: 1,
  Registered: 2,
  InProgress: 3,
  Completed: 4,
  Finished: 5,
  Absent: 6,
});
export default statuses;
